import React from 'react';

import InnerCallList from '../../call/InnerCallList';

class CallTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
        <div className={`tab-pane fade ${tab === 'call' ? 'show active in' : ''}`}>
            <div className="row">
                <div className="col-md-12">
                <InnerCallList {...this.props} id={this.props.id} type={this.props.type}
                  reload={this.props.reload} edit={this.props.edit} />
                </div>
            </div>
        </div>
    );
  }
}
export default CallTab;